module.exports = __webpack_public_path__ + "img/thermometer-title.71e42c1e.png";